import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFrequentProducts } from "../../../../redux/Thunk/Product/ProductThunks";
import { extentions } from "../../../../utils/constants";

const Frequent = () => {
  const products = useSelector((state) => state?.product?.frequentProduct);
  const doctorId = useSelector((state) => state?.doctor?.doctorById?.DID);

  const dispatch = useDispatch();

  useEffect(() => {
    if (doctorId) {
      dispatch(fetchFrequentProducts(doctorId));
    }
  }, [doctorId, dispatch]);

  return (
    <div>
      <h1 className="text-lg font-semibold mb-4">Frequent Items</h1>
      <div className="space-y-4">
        {products?.length > 0 ? (
          products?.map((product) => {
            const currentStoreStock = product?.product?.storeProducts?.find(
              (storeProduct) => storeProduct?.SID === product?.SID
            );
            return (
              <div
                key={product?.IID}
                className="flex items-start bg-primary-50/50 rounded-lg p-4 max-w-[450px]"
              >
                {/* <div className="w-12 h-12 bg-green-200 flex items-center justify-center rounded-md mr-4">
								<span className="text-black text-sm">xxx</span>
							</div> */}
                <div>
                  <h2 className="text-black-lose font-medium text-base capitalize">
                    {product?.product?.productName || ""}
                  </h2>
                  <p className="text-primary-400 text-xs">
                    {product?.product?.type} . {product?.product?.uom}&nbsp;
                    {extentions[product?.product?.type]?.uomExt || extentions[product?.product?.type]?.extention || ""}
                  </p>
                  {product?.product?.drugs &&
                  product?.product?.drugs.length > 0 ? (
                    <span className="text-primary-400 text-xs">
                      {product.product.drugs
                        .map((drug) => (drug?.name ? drug.name : drug))
                        .join(", ")}
                    </span>
                  ) : (
                    <p>No drugs</p>
                  )}
                </div>
                <div className="ml-auto">
                  <p className="text-success-600">
                    {currentStoreStock?.storeStock || 0}
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <p> No Product found</p>
        )}
      </div>
    </div>
  );
};

export default Frequent;
